import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { SportBlocLockup } from './SportBlocLogo';

const Footer = () => {
  return (
    <footer className="bg-black text-gray-300 border-t border-yellow-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <SportBlocLockup sealSize={40} dark={true} />
            </div>
            <p className="text-sm mb-4">
              Experience sports like never before. Premium facilities for futsal and pickleball across multiple locations.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 rounded-full bg-yellow-400/10 flex items-center justify-center hover:bg-yellow-400/20 transition-colors">
                <Facebook className="w-4 h-4 text-yellow-400" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-yellow-400/10 flex items-center justify-center hover:bg-yellow-400/20 transition-colors">
                <Instagram className="w-4 h-4 text-yellow-400" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-yellow-400/10 flex items-center justify-center hover:bg-yellow-400/20 transition-colors">
                <Twitter className="w-4 h-4 text-yellow-400" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-yellow-400 transition-colors">Home</Link></li>
              <li><Link to="/locations" className="hover:text-yellow-400 transition-colors">Our Locations</Link></li>
              <li><Link to="/book" className="hover:text-yellow-400 transition-colors">Book Now</Link></li>
              <li><Link to="/store" className="hover:text-yellow-400 transition-colors">Sports Store</Link></li>
              <li><Link to="/gallery" className="hover:text-yellow-400 transition-colors">Gallery</Link></li>
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Locations</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <div className="font-semibold text-yellow-400">Football Arena</div>
                <div className="text-gray-400">Futsal • Shillong</div>
              </li>
              <li>
                <div className="font-semibold text-yellow-400">Racquet Sports Arena</div>
                <div className="text-gray-400">Pickleball • Shillong</div>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-0.5 text-yellow-400" />
                <span>info@thesportbloc.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 mt-0.5 text-yellow-400" />
                <span>+91 98765 43210</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 text-yellow-400" />
                <span>Shillong, Meghalaya, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-yellow-500/20 mt-8 pt-8 text-center text-sm">
          <p>&copy; 2026 The Sport Bloc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;